import React, { useState, useEffect } from "react";
import { Button, Confirm, Grid, Header, Label, Segment } from "semantic-ui-react";
import format from "date-fns/format";
import { uploadCostingFile, deleteCostingFile } from "../leadActions";

import firebase from "../../../app/config/firebase";
const firestore = firebase.firestore();

export default function LeadDetailedCostings(props) {
    const [files, setFiles] = useState([]);
    const [uploadFile, setUploadFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    useEffect(() => {
        const unsubscribe = firestore
            .collection("leads")
            .doc(props.lead.id)
            .collection("costing_files")
            .onSnapshot((snapshot) => {
                let list = [];

                snapshot.docs.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), ["id"]: `${doc.id}` };
                        list.push(appObj);
                    }
                });

                list.sort((a, b) => (a.createDate < b.createDate ? 1 : -1));
                setFiles(list);
            });

        return () => unsubscribe();
    }, []);

    async function handleUpload() {
        if (!uploadFile) {
            return;
        }

        setUploading(true);

        await uploadCostingFile({
            leadId: props.lead.id,
            displayName: props.currentUserProfile?.displayName || "",
            userUid: props.currentUserProfile?.id || "",
            uploadFile: uploadFile,
        });

        setUploadFile(null);
        const input = document.getElementById("costingUploadFile");
        if (input) {
            input.value = "";
        }
        setUploading(false);
    }

    async function handleDelete() {
        await deleteCostingFile(props.lead.id, deleteTarget);
        setDeleteTarget(null);
    }

    return (
        <div style={{ marginBottom: 20 }}>
            <Segment attached="top">
                <Header as="h3">Costing Calculations</Header>
            </Segment>

            <Segment attached>
                <p>
                    <a href="/templates/Costing_Calculations_Template.xlsx" download>
                        Download blank template
                    </a>
                </p>

                {files && files.length > 0 ? (
                    files.map((file, index) => (
                        <p key={file.id}>
                            <strong>{file.fileName}</strong>{" "}
                            {index === 0 && (
                                <Label color="orange" size="tiny">
                                    Current
                                </Label>
                            )}
                            <br />
                            Uploaded {format(file.createDate.toDate(), "d MMMM yyyy HH:mm")}
                            {file.displayName ? ` by ${file.displayName}` : ""}
                            <br />
                            <a href={file.fileUrl} target="_blank" rel="noopener noreferrer">
                                Download
                            </a>
                            {" | "}
                            <a
                                href="#delete"
                                onClick={(event) => {
                                    event.preventDefault();
                                    setDeleteTarget(file);
                                }}
                            >
                                Delete
                            </a>
                        </p>
                    ))
                ) : (
                    <p>No costing files uploaded yet. Download the blank template to get started.</p>
                )}
            </Segment>

            <Segment attached="bottom">
                <Grid verticalAlign="middle">
                    <Grid.Row>
                        <Grid.Column width={5}>
                            <label>
                                <strong>Upload Costing</strong>
                            </label>
                        </Grid.Column>

                        <Grid.Column width={11}>
                            <input
                                id="costingUploadFile"
                                name="costingUploadFile"
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                onChange={(event) => {
                                    setUploadFile(event.currentTarget.files[0]);
                                }}
                                className="form-control"
                            />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Button
                    style={{ marginTop: 20 }}
                    disabled={uploading || !uploadFile}
                    loading={uploading}
                    color="orange"
                    content="Upload Costing"
                    onClick={() => handleUpload()}
                />
            </Segment>

            <Confirm
                header="Delete this costing file?"
                content={deleteTarget ? `${deleteTarget.fileName} will be permanently deleted. This cannot be undone.` : ""}
                size="tiny"
                open={deleteTarget !== null}
                onCancel={() => setDeleteTarget(null)}
                onConfirm={() => handleDelete()}
                confirmButton="Delete"
            />
        </div>
    );
}
